import * as _ from 'lodash-es';
import React from 'react';
import Button from '../../components/Button';
import { Cards } from '../../components/Card';
import { UPCOMING_PLATFORM_INFO_MAP } from '../../integrations/IntegrationPlatformInfo';
import ExternalServiceCard from '../ExternalServiceCard';
import useRequestIntegrationMutation from './useRequestIntegrationMutation';

interface UpcomingIntegrationsProps {
  platforms: string[];
}

const UpcomingIntegrations = ({ platforms }: UpcomingIntegrationsProps) => {
  const requestIntegration = useRequestIntegrationMutation();

  const request = (platform: {
    name: string;
    website: string;
    description: string;
  }) => {
    requestIntegration(platform.name, platform.website, platform.description);
  };

  const upcomingPlatforms = _.compact(
    platforms.map((platform) => UPCOMING_PLATFORM_INFO_MAP[platform]),
  );

  if (upcomingPlatforms.length < 0) {
    return null;
  }

  return (
    <Cards>
      {upcomingPlatforms.map((platform) => (
        <ExternalServiceCard
          key={platform.platform}
          action={
            <Button variant="secondary" onClick={() => request(platform)}>
              Request
            </Button>
          }
          icon={platform.icon}
          name={platform.name}
          details={platform.description}
        />
      ))}
    </Cards>
  );
};

export default UpcomingIntegrations;
